import ExpertsHero from "./components/ExpertsHero";
import ExpertsWhatIs from "./components/ExpertsWhatIs";
import ExpertsDomains from "./components/ExpertsDomains";
import ExpertsProcess from "./components/ExpertsProcess";
import ExpertsPathwayNav from "./components/ExpertsPathwayNav";
import ExpertsOutcomes from "./components/ExpertsOutcomes";

export default function Experts() {
  return (
    <main className="min-h-screen">
      <ExpertsHero />
      <ExpertsWhatIs />
      <ExpertsDomains />
      <ExpertsProcess />
      <ExpertsPathwayNav />
      <ExpertsOutcomes />
    </main>
  );
}